import React from 'react';
import {
    Dialog, DialogTitle, DialogContent, DialogActions, IconButton,
    List, ListItemButton, ListItemText, Typography, Button, CircularProgress, Box,
} from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import useDataFetch from '../hooks/useDataFetch';
import { getFields, searchFields } from '../utils/fields';
import SearchForm from '../components/SearchForm';
import Pagination from '../components/Pagination';

const SupplierSelectModal = ({ isOpen, onClose, onSelectSupplier }) => {

    const {
        dataset: suppliers,
        loading,
        error,
        currentPage,
        totalPages,
        searchQuery,
        handleSearchChange,
        handleSearchSubmit,
        handleClearSearch,
        handlePageChange,
    } = useDataFetch('/supplier', {
        supplier_code: '',
        supplier_name: '',
        is_active: true, // 仕入先のみ有効データを取得
    });

    // 検索対象フィールドを仕入先用に調整
    const searchItems = getFields(searchFields, ['supplier_name']);

    return (
        <Dialog
            open={isOpen}
            onClose={onClose}
            fullWidth
            maxWidth="md"
        >
            {/* タイトル */}
            <DialogTitle sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                仕入先選択
                <IconButton onClick={onClose}>
                    <CloseIcon />
                </IconButton>
            </DialogTitle>

            <DialogContent dividers>

                {/* 検索フォーム */}
                <SearchForm
                    searchQuery={searchQuery}
                    searchFields={searchItems}
                    handleSearchChange={handleSearchChange}
                    handleSearchSubmit={handleSearchSubmit}
                    handleClearSearch={handleClearSearch}
                />

                {/* 仕入先リスト */}
                {loading ? (
                    <Box display="flex" justifyContent="center" py={4}>
                        <CircularProgress />
                    </Box>
                ) : error ? (
                    <Typography color="error">
                        {error}
                    </Typography>
                ) : suppliers.length > 0 ? (
                    <List sx={{ maxHeight: 400, overflow: 'auto' }}>
                        {suppliers.map(supplier => (
                            <ListItemButton
                                key={supplier.supplier_id}
                                onClick={() => onSelectSupplier(supplier)}
                            >
                                <ListItemText
                                    primary={`${supplier.supplier_name}`}
                                    secondary={supplier.supplier_phone ?? ''}
                                />
                            </ListItemButton>
                        ))}
                    </List>
                ) : (
                    <Typography>仕入先データがありません。</Typography>
                )}

                {/* ページネーション */}
                <Pagination
                    currentPage={currentPage}
                    totalPages={totalPages}
                    onPageChange={handlePageChange}
                />

            </DialogContent>

            <DialogActions>
                <Button onClick={onClose} variant="outlined">
                    閉じる
                </Button>
            </DialogActions>
        </Dialog>
    );
};

export default SupplierSelectModal;